export default __webpack_public_path__ + "static/media/Stage2.fc446510.svg";